import { useFormik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import { ComonIcons } from "../contents/commonIcons";
import { setPushNotificationModal } from "../redux/actions/member/memberAction";
import Title from "./title";
import * as Yup from "yup";
import { getMembers, pushNotification } from "../redux/actions/api/apiAction";
import { toastr } from "react-redux-toastr";

export const PushNotification = ({ selectedMember }) => {
  const dispatch = useDispatch();
  const { pushNotificationModalOpen, members } = useSelector(
    (state) => state.member
  );
  const {commonLoading}=useSelector((state)=>state.common)
  const toggle = () =>
    dispatch(setPushNotificationModal(!pushNotificationModalOpen));

  const initialValues = {
    title: "",
    body: "",
  };

  React.useEffect(() => {
    if (!selectedMember.length&&pushNotificationModalOpen) {
      dispatch(
        getMembers(
          1,
          9999999,
          JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
        )
      );
    }
  }, [pushNotificationModalOpen]);
  const hanldeSubmit = (values) => {
    if (!selectedMember.length) {
      return toastr.error(
        "Please select member/members to push notification to them"
      );
    } else {
      dispatch(
        pushNotification({
          ...values,
          members: selectedMember,
        })
      );
    }
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    body: Yup.string().required("Body is required"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: hanldeSubmit,
    validationSchema: validationSchema,
  });

  return (
    <Modal
      centered={true}
      size={"lg"}
      className="large-pop adding-popup "
      isOpen={pushNotificationModalOpen}
      toggle={toggle}
    >
      <ModalBody>
        <div className="bg-white mx-2">
          <div className="d-flex align-items-center border-bottom-1 pb-4 mb-4">
            <div className="d-inline-flex ">
              <Title
                title={`Push Notification ${
                  !selectedMember?.length ? "To All Members" : ""
                }`}
              />
            </div>
            <div className="d-inline-flex ml-auto">
              <div className="close-icons pb-0">
                <div className="text-right">
                  <span
                    className="svg-block"
                    onClick={() => {
                      toggle();
                    }}
                  >
                    {ComonIcons.closeBlack}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <form onSubmit={formik.handleSubmit}>
            <Row>
              <Col md={12}>
                <FormGroup className="custom-inputs mb-md-0 ">
                  <Input
                    name="title"
                    type="text"
                    maxLength={65}
                    className={
                      formik.errors.title &&
                      formik.touched.title &&
                      "is-invalid"
                    }
                    onChange={(e) =>
                      formik.setFieldValue("title", e.target.value)
                    }
                  />
                  <Label for="date">Title</Label>
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup className="custom-inputs mb-md-0 ">
                  <Input
                    name="body"
                    type="textarea"
                    maxLength={1000}
                    placeholder="Notification Body"
                    className={` mt-3 mb-5
                     ${formik.errors.body &&
                       formik.touched.body &&
                       "is-invalid"}
                    `}
                    onChange={formik.handleChange}
                    min={1}
                  />
                  <Label for="body">Notification Body</Label>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12} className="d-flex justify-content-center">
                <button
                  className="btn btn-primary btn-small mr-3"
                  onClick={toggle}
                  type="click"
                >
                  Cancel
                </button>
                <button className="btn btn-danger btn-small" type="submit" disabled={commonLoading}>
                    {commonLoading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      "Push Notification"
                    )}{" "}
                </button>
              </Col>
            </Row>
          </form>
        </div>
      </ModalBody>
    </Modal>
  );
};
